import useWindowSize from "./useWindowSize";

export default function useDeviceType() {
    const { width } = useWindowSize();

    const isDesktop = width > 767;
    const isMobile = width <= 767;

    let deviceType = "Desktop";
    if (isMobile) {
      deviceType = "Mobile";
    }
    
    return deviceType;
}
